import { contentsItems } from "@/mocks/home";

export default function ContentsSection() {
  return (
    <section
      id="contents"
      className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50"
    >
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-10 md:mb-14">
          <p className="font-label text-xs tracking-[0.2em] text-primary-700 mb-3">
            本期目录
          </p>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug mb-4">
            这一期收了什么，先看梗概
          </h2>
          <p className="text-sm md:text-base leading-7 text-foreground-600">
            每条下面都写了角度和时长，看完短摘要就能决定要不要往下点。顺序按整理时间排，不按热度。
          </p>
        </div>

        <div className="border-b border-background-200">
          {contentsItems.map((item) => (
            <a
              key={item.no}
              href="#entry"
              className="group block border-t border-background-200 py-5 md:py-7 transition-colors hover:bg-background-100/70 cursor-pointer"
            >
              <div className="grid grid-cols-1 md:grid-cols-12 gap-3 md:gap-6 items-start md:items-center px-1 md:px-3">
                <div className="md:col-span-1">
                  <span className="font-heading text-xl md:text-2xl text-primary-500">
                    {item.no}
                  </span>
                </div>
                <div className="md:col-span-7">
                  <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-foreground-600">
                    {item.summary}
                  </p>
                </div>
                <div className="md:col-span-4 flex items-center md:justify-end gap-3 flex-wrap">
                  <span className="inline-flex items-center h-7 px-3 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label whitespace-nowrap">
                    {item.format}
                  </span>
                  <span className="text-xs text-foreground-500 font-label whitespace-nowrap">
                    {item.duration}
                  </span>
                  <span className="w-8 h-8 rounded-full border border-background-300 flex items-center justify-center text-foreground-500 group-hover:bg-primary-500 group-hover:text-background-50 group-hover:border-primary-500 transition-colors">
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}